export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/react-router/es/PromiseUtils.js
// module id = 830
// module chunks = 0